var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8521_4683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76384 35.8898C10.1368 35.5297 10.6369 35.3314 11.1553 35.3381H59.1361C59.3259 35.3424 59.5103 35.4015 59.6672 35.5083C59.8241 35.6152 59.9468 35.7653 60.0203 35.9403C60.0939 36.1153 60.1152 36.3078 60.0818 36.4947C60.0483 36.6815 59.9615 36.8548 59.8318 36.9934L50.2117 46.3736C50.035 46.5577 49.8226 46.7037 49.5875 46.8028C49.3523 46.9018 49.0994 46.9517 48.8442 46.9493H0.863406C0.673622 46.945 0.489154 46.8857 0.332255 46.7789C0.175357 46.672 0.0527298 46.5221 -0.0208229 46.3471C-0.0943757 46.1721 -0.115715 45.9796 -0.0822669 45.7927C-0.0488184 45.6058 0.0379898 45.4326 0.167682 45.294L9.76384 35.8898Z",
    fill: "url(#paint0_linear_8521_4683)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76379 0.575746C10.1343 0.209079 10.6339 0.00238022 11.1552 8.71405e-08H59.136C59.3306 -8.17876e-05 59.5209 0.0575332 59.6827 0.165608C59.8446 0.273682 59.9707 0.427446 60.0452 0.607228C60.1196 0.78701 60.1391 0.984797 60.1011 1.17565C60.0631 1.36651 59.9694 1.5418 59.8318 1.67936L50.2356 11.1316C49.8724 11.4946 49.3816 11.7012 48.8682 11.7073H0.887336C0.692737 11.7074 0.502494 11.6498 0.340665 11.5417C0.178835 11.4336 0.0526959 11.28 -0.0217851 11.1002C-0.096266 10.9205 -0.115743 10.7225 -0.0777563 10.5317C-0.0397694 10.3408 0.0539781 10.1655 0.191621 10.028L9.76379 0.575746Z",
    fill: "url(#paint1_linear_8521_4683)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2117 18.1369C50.035 17.9527 49.8226 17.8067 49.5875 17.7077C49.3523 17.6087 49.0994 17.5588 48.8442 17.5611H0.863406C0.673622 17.5655 0.489154 17.6247 0.332255 17.7316C0.175357 17.8384 0.0527298 17.9884 -0.0208229 18.1634C-0.0943757 18.3384 -0.115715 18.5309 -0.0822669 18.7177C-0.0488184 18.9046 0.0379898 19.0778 0.167682 19.2165L9.76384 28.6687C9.94324 28.8558 10.1596 29.0036 10.3991 29.1027C10.6386 29.2018 10.8961 29.2501 11.1553 29.2444H59.1361C59.3259 29.2401 59.5103 29.181 59.6672 29.0741C59.8241 28.9673 59.9468 28.8172 60.0203 28.6422C60.0939 28.4672 60.1152 28.2747 60.0818 28.0878C60.0483 27.9009 59.9615 27.7277 59.8318 27.5891L50.2117 18.1369Z",
    fill: "url(#paint2_linear_8521_4683)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8521_4683",
    x1: 54.458,
    y1: -5.66126,
    x2: 21.3276,
    y2: 57.8411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8521_4683",
    x1: 39.9677,
    y1: -13.2187,
    x2: 6.81291,
    y2: 50.2599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8521_4683",
    x1: 47.1649,
    y1: -9.45205,
    x2: 14.0342,
    y2: 54.0265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8521_4683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 47.0212,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.f5c42e53d25ca33345bebbd9ddfd45d1.svg";
export { ForwardRef as ReactComponent };